import { useTranslation } from 'react-i18next';

interface TimelineScrubberProps {
  maxDay: number;
  visibleDay: number;
  onChange: (day: number) => void;
}

export function TimelineScrubber({ maxDay, visibleDay, onChange }: TimelineScrubberProps) {
  const { t } = useTranslation('game');

  if (maxDay === 0) return null;

  return (
    <div className="flex items-center gap-3 px-1 pb-3 border-b border-mafia-border/50">
      <span className="text-[10px] font-mono text-mafia-muted uppercase tracking-wider shrink-0">
        {t('board.timeline.label')}
      </span>
      <input
        type="range"
        min={0}
        max={maxDay}
        value={visibleDay}
        onChange={(e) => onChange(Number(e.target.value))}
        className="flex-1 accent-mafia-gold"
      />
      <span className="text-[10px] font-mono text-mafia-gold shrink-0 min-w-[3rem] text-right">
        {visibleDay === 0 ? t('board.timeline.all') : `${t('board.timeline.label')} ${visibleDay}`}
      </span>
    </div>
  );
}
